/*
 * asb-collection-readmore.js
 * Aspen Ski and Board
 *
 * Collapses long text blocks on collection pages so the product grid
 * sits higher up on phones. MOBILE ONLY (max-width: 768px). Desktop is
 * untouched.
 *
 * What it collapses:
 *   1. The collection description in the banner (.collection-banner .rte)
 *   2. Any rich-text info section whose section id ends in "_info"
 *      (boot_fit_info, skis_info, sb_info, goggles_info, etc.)
 *      Only the body text collapses. The heading stays visible.
 *
 * What it does NOT touch:
 *   - The phone CTA promo strip
 *   - The icon bar (icons-with-text)
 *   - Anything on desktop
 *
 * SEO note: all text stays in the HTML at page load. Nothing is fetched
 * on click, so search engines still read the full description.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 768px)';
  var MAX_H = 110; // px. Roughly 4 lines of body copy.
  var LABEL_MORE = 'Read more';
  var LABEL_LESS = 'Read less';

  function injectStyles() {
    if (document.getElementById('asb-readmore-styles')) return;
    var s = document.createElement('style');
    s.id = 'asb-readmore-styles';
    s.textContent = [
      '@media (max-width: 768px) {',
      '  .asb-clamp { overflow: hidden; max-height: ' + MAX_H + 'px; transition: max-height .25s ease; }',
      '  .asb-clamp.is-open { max-height: 4000px; }',
      '  .asb-readmore-btn { display: inline-block; margin-top: 10px; padding: 0; border: 0; background: none;',
      '    font: inherit; font-weight: 700; text-decoration: underline; text-underline-offset: 3px;',
      '    cursor: pointer; color: inherit; }',
      '}',
      '@media (min-width: 769px) {',
      '  .asb-clamp { max-height: none !important; overflow: visible !important; }',
      '  .asb-readmore-btn { display: none !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function clamp(el) {
    if (!el || el.getAttribute('data-asb-readmore')) return;

    // Leave short blocks alone. Nothing to collapse.
    if (el.scrollHeight <= MAX_H + 16) return;

    el.setAttribute('data-asb-readmore', '1');
    el.classList.add('asb-clamp');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'asb-readmore-btn';
    btn.textContent = LABEL_MORE;
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.textContent = open ? LABEL_LESS : LABEL_MORE;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    el.parentNode.insertBefore(btn, el.nextSibling);
  }

  function init() {
    if (!window.matchMedia || !window.matchMedia(MOBILE).matches) return;

    injectStyles();

    var targets = [];

    // 1. Collection description under the H1.
    var desc = document.querySelector('.collection-banner .rte');
    if (desc) targets.push(desc);

    // 2. Rich-text info sections that sit above the product grid.
    var products = document.getElementById('shopify-section-collection-products');
    var infos = document.querySelectorAll('[id^="shopify-section-"][id$="_info"]');

    for (var i = 0; i < infos.length; i++) {
      var sec = infos[i];

      // Skip anything that sits below the product grid. It is already out of the way.
      if (products && !(sec.compareDocumentPosition(products) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        continue;
      }

      var rte = sec.querySelector('.rte');
      if (rte) targets.push(rte);
    }

    for (var j = 0; j < targets.length; j++) {
      clamp(targets[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
